import api from '../../util/api'
import _ from 'lodash'
import VueSimpleAlert from 'vue-simple-alert'
import Common from '../../util/common'

const state = {
  selectedConfig: {},
  config: {},
  stationId: '3423050040',
  windcaveUat: false,
  printerName: 'XP-80C BT',
}

const getters = {
  config: (state) => {
    return state.config
  },
  selectedConfig: (state) => {
    return state.selectedConfig
  },
  selectedStationId: (state) => {
    return state.stationId
  },
  useWindcaveUat: (state) => {
    return state.windcaveUat
  },
  selectedPrinterName: (state) => {
    return state.printerName
  },
}

const actions = {
  getConfig({ commit, dispatch }, args) {
    api
      .getConfig()
      .then((response) => {
        commit('setConfig', response.data)

        var config = {}
        var selected = localStorage.getItem('selected_config') ? JSON.parse(Common.atobUtf8(localStorage.getItem('selected_config'))) : undefined
        if (selected && selected.AccountName) {
          config = _.find(response.data, { AccountName: selected.AccountName })
        } else {
          config = response.data[0]
        }

        commit('setSelectedConfig', config)

        args.callback()
      })
      .catch((e) => {
        VueSimpleAlert.alert(`Failure getting config data: ${e}`)
      })
  },
  getStationId({ commit }) {
    commit('setSelectedStationId', localStorage.getItem('selected_stationId'))
  },
  getWindaveUat({ commit }) {
    commit('setWindcaveUat', localStorage.getItem('selected_windcaveUat'))
  },
  getSelectedPrinterName({ commit }) {
    commit('setSelectedPrinterName', localStorage.getItem('selected_printerName'))
  },
  setConfig({ commit }, config) {
    if (!config || !config.AccountName) return
    commit('setSelectedConfig', config)
  },
  setStationId({ commit }, stationId) {
    if (!stationId) return
    commit('setSelectedStationId', stationId)
  },
  setWindcaveUat({ commit }, val) {
    commit('setWindcaveUat', val)
  },
  setPrinterName({ commit }, printerName) {
    if (!printerName) return
    commit('setSelectedPrinterName', printerName)
  },
}

const mutations = {
  setConfig(state, config) {
    state.config = config
  },
  setSelectedConfig(state, config) {
    state.selectedConfig = config
    try {
      localStorage.selected_config = Common.btoaUtf8(JSON.stringify(state.selectedConfig))
    } catch (error) {
      console.error('Error setting selected config:', error)
    }

  },
  setSelectedStationId(state, stationId) {
    state.stationId = stationId
    localStorage.selected_stationId = stationId
  },
  setWindcaveUat(state, val) {
    state.windcaveUat = val
    localStorage.selected_windcaveUat = val
  },
  setSelectedPrinterName(state, val) {
    state.printerName = val
    localStorage.selected_printerName = val
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
